import './App.css';
import PageHeader from './PageHeader.js';
import SubscriptionRule from './SubscriptionRule.js';
import SubscriptionCode from './SubscriptionCode.js';
import React, { useState } from "react";
import { Tabs, Button } from "@anchor/react-components";
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from '@azure/msal-react';
import { loginRequest } from './authConfig';

function SubscriptionContent() {

  const [activePage, setActivePage] = useState([
    {
      active: true,
      id: 'subscription_code',
      title: 'Subscription Filtering Code',
      icon: 'info-circle-solid'

    },
    {
      active: false,
      id: 'subscription_rule',
      title: 'Subscription Filtering Rule',
      icon: 'info-circle-solid',

    }
  ]);
  return (
    <div >
      <div>
        <PageHeader />
      </div>

      <div style={{ "width": "80%" }}>
        <div >
          <div >
            <Tabs
              items={activePage}
              onClick={(e) => setActivePage(e.updatedTabData)}
              type="justified"
            />
          </div>
        </div>
      </div>

      <div style={{ "width": "80%" }}>
        <div >
          {
            (activePage[0]["active"] === true) ?
              <div>
                <SubscriptionCode />
              </div>
              : ''
          }
          {
            (activePage[1]["active"] === true) ?
              <div >
                <SubscriptionRule />
              </div>
              : ''
          }
        </div>
      </div>
    </div>
  );
}

const MainContent = () => {
  /**
   * useMsal is hook that returns the PublicClientApplication instance,
   * that tells you what msal is currently doing. For more, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
   */
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const handleRedirect = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: 'create',
      })
      .catch((error) => console.log(error));
  };

  return (
    <div>
      <AuthenticatedTemplate>
        {activeAccount ? (
          <p>
            <SubscriptionContent />
          </p>
        ) : null}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div >
          <div>
            <PageHeader />
          </div>
          <div style={{ "width": "80%", "margin-top": "100px", "margin-bottom": "100px", "text-align": "center" }}>
            You are currently not logged-in
          </div>
          <div style={{ "width": "80%", "text-align": "center" }}>
            <Button
              appearance="default"
              id="primary2"
              label="Sign In"
              width="40"
              name="primary2"
              onClick={handleRedirect}
              title="SIGNIN"
              variant="filledAlt"
              fit="small"
            />
          </div >
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
};

const App = ({ instance }) => {
  return (
    <MsalProvider instance={instance}>
      <MainContent />
    </MsalProvider>
  );
};

export default App;
